import { render, staticRenderFns } from "./SignedTxModal.vue?vue&type=template&id=5c679e44&"
import script from "./SignedTxModal.vue?vue&type=script&lang=js&"
export * from "./SignedTxModal.vue?vue&type=script&lang=js&"
import style0 from "./SignedTxModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports